import { GetPlayerTrailResponse } from './tournament.interface';

export const MOCK_PLAYER_TRAIL: GetPlayerTrailResponse = {
    player: {
        id_site: '123456',
        avatar: 'https://i.pravatar.cc/40?img=1',
        nome_abreviado: 'Rafael Queiroz',
        idade: 12,
        sigla_uf: 'DF',
        nome_cidade: 'Brasília',
    },
    tournament: {
        id_torneio: '21237',
        nome_torneio: 'ITF BTJ100 - Circuito Next Gen - Etapa Sinop',
        tipo_torneio: '1',
    },
    games: [
            {
                id_categoria: '653',
                category: '12 Anos Masculino - A',
                group: [
                    {
                        id_jogo: '2198070',
                        id_proximo_jogo: '2198074',
                        dt_jogo: '23/07/2025',
                        hr_jogo: '09:00:00',
                        resultado_1: '1',
                        resultado_2: '0',
                        nr_rodada: '6',
                        nr_jogo: '1',
                        players: {
                            1: [
                                {
                                    id_site: '123456',
                                    avatar: 'https://i.pravatar.cc/40?img=1',
                                    nome_abreviado: 'Rafael Queiroz',
                                    idade: 12,
                                    sigla_uf: 'DF',
                                    nome_cidade: 'Brasília',
                                },
                            ],
                            2: [
                                {
                                    id_site: '789012',
                                    avatar: 'https://i.pravatar.cc/40?img=2',
                                    nome_abreviado: 'Bernardo Rocha',
                                    idade: 12,
                                    sigla_uf: 'DF',
                                    nome_cidade: 'Brasília',
                                },
                            ],
                        },
                     },
                     {
                         id_jogo: '2198070',
                         id_proximo_jogo: '2198074',
                         dt_jogo: '25/07/2025',
                         hr_jogo: '09:00:00',
                         resultado_1: '0',
                         resultado_2: '1',
                         nr_rodada: '7',
                         nr_jogo: '1',
                        players: {
                            1: [
                                {
                                    id_site: '123456',
                                    avatar: 'https://i.pravatar.cc/40?img=1',
                                    nome_abreviado: 'Rafael Queiroz',
                                    idade: 12,
                                    sigla_uf: 'DF',
                                    nome_cidade: 'Brasília',
                                },
                            ],
                            2: [
                                {
                                    id_site: '345678',
                                    avatar: 'https://i.pravatar.cc/40?img=2',
                                    nome_abreviado: 'Luca Plebani',
                                    idade: 12,
                                    sigla_uf: 'SP',
                                    nome_cidade: 'São Paulo',
                                },
                            ],
                        },
                    },
                    {
                         id_jogo: '2198070',
                         id_proximo_jogo: '2198074',
                         dt_jogo: '27/07/2025',
                         hr_jogo: '09:00:00',
                         resultado_1: '1',
                         resultado_2: '0',
                         nr_rodada: '8',
                         nr_jogo: '1',
                        players: {
                            1: [
                                {
                                    id_site: '123456',
                                    avatar: 'https://i.pravatar.cc/40?img=1',
                                    nome_abreviado: 'Rafael Queiroz',
                                    idade: 12,
                                    sigla_uf: 'DF',
                                    nome_cidade: 'Brasília',
                                },
                            ],
                            2: [
                                {
                                    id_site: '567890',
                                    avatar: 'https://i.pravatar.cc/40?img=2',
                                    nome_abreviado: 'Cauã Cohen',
                                    idade: 12,
                                    sigla_uf: 'SP',
                                    nome_cidade: 'São Paulo',
                                 },
                             ],
                         },
                    },
                ],
            },
        ],
};

export const MOCK_PLAYERS = [
    {
        id_site: '123456',
        nome_abreviado: 'Rafael Queiroz',
        avatar: 'https://i.pravatar.cc/40?img=1',
        idade: 12,
        nome_cidade: 'Brasília',
        sigla_uf: 'DF',
    },
    {
        id_site: '789012',
        nome_abreviado: 'Bernardo Rocha',
        avatar: 'https://i.pravatar.cc/40?img=2',
        idade: 12,
        nome_cidade: 'Brasília',
        sigla_uf: 'DF',
    },
    {
        id_site: '345678',
        nome_abreviado: 'Luca Plebani',
        avatar: 'https://i.pravatar.cc/40?img=3',
        idade: 12,
        nome_cidade: 'São Paulo',
        sigla_uf: 'SP',
    },
    {
        id_site: '567890',
        nome_abreviado: 'Cauã Cohen',
        avatar: 'https://i.pravatar.cc/40?img=4',
        idade: 12,
        nome_cidade: 'São Paulo',
        sigla_uf: 'SP',
    },
];
